// extracted by mini-css-extract-plugin
module.exports = {"imgvideoPc":"EditorImgVideo_imgvideoPc__eCiuh","imgvideoH5":"EditorImgVideo_imgvideoH5__JfvG9"};